exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#custom-btn-component {\n  min-width: 0px;\n  padding: 0px;\n  line-height: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/component/input-number/input.number.component.scss
// module id = ../../../../../src/app/shared/component/input-number/input.number.component.scss
// module chunks = main